(function () {
  'use strict';
  var key = '__blackFridayTimeline';
  if (window[key]) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window[key].initWithin(document); }, { once: true });
    else window[key].initWithin(document);
    return;
  }
  var cleanups = new WeakMap();

  // Match the countdown's explicit-offset format; never use a visitor's timezone.
  function parseStart(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value.trim());
    if (!match) return NaN;
    var year = +match[1], month = +match[2], day = +match[3], hour = +match[4], minute = +match[5], second = +(match[6] || '00'), offset = match[7];
    var date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59) return NaN;
    if (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4) > 59 || (+offset.slice(1, 3) === 14 && +offset.slice(4) !== 0))) return NaN;
    return Date.parse(value.trim());
  }

  function init(root) {
    if (cleanups.has(root)) return;
    var stages = Array.from(root.querySelectorAll('[data-bf-timeline-stage]'));
    if (!stages.length) return;
    var entries = stages.map(function (stage) { return { stage: stage, time: parseStart(stage.dataset.stageStartAt || '') }; }).filter(function (entry) { return Number.isFinite(entry.time); });
    var automatic = root.dataset.bfTimelineAuto !== 'false' && entries.length > 0;
    var events = new AbortController();
    var options = { signal: events.signal };
    var renderedTime = Number(root.dataset.serverNow) * 1000;
    var clockTime = Number.isFinite(renderedTime) && renderedTime > 0 ? renderedTime : NaN;
    var clockAt = performance.now();
    var lastAttempt = -Infinity;
    var syncing = false;
    var timer = 0;
    var revealFrame = 0;
    var revealPending = null;
    var active;
    var applied = false;
    var observer = null;

    function reveal(stage, animate) {
      revealPending = stage;
      cancelAnimationFrame(revealFrame);
      revealFrame = requestAnimationFrame(function () {
        revealFrame = 0;
        if (events.signal.aborted || !root.isConnected || document.hidden || !root.clientWidth || !stage.getClientRects().length) return;
        if (root.scrollWidth > root.clientWidth + 1) {
          root.scrollTo({ left: root.scrollLeft, behavior: 'instant' });
          var padding = parseFloat(getComputedStyle(root).paddingLeft) || 0;
          var left = root.scrollLeft + stage.getBoundingClientRect().left - root.getBoundingClientRect().left - padding;
          left = Math.max(0, Math.min(root.scrollWidth - root.clientWidth, left));
          root.scrollTo({ left: left, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
        }
        revealPending = null;
      });
    }
    function manual() {
      stages.forEach(function (stage) {
        var selected = stage.dataset.bfTimelineHighlight === 'true';
        stage.classList.toggle('is-highlighted', selected);
        if (selected) stage.setAttribute('aria-current', 'step');
        else stage.removeAttribute('aria-current');
      });
    }
    function now() { return clockTime + Math.max(0, performance.now() - clockAt); }
    function update() {
      clearTimeout(timer);
      if (events.signal.aborted) return;
      if (!root.isConnected) { cleanup(); return; }
      var currentTime = now();
      var next = Infinity;
      if (Number.isFinite(currentTime)) {
        var current = null;
        entries.forEach(function (entry) {
          if (entry.time <= currentTime && (!current || entry.time >= current.time)) current = entry;
          if (entry.time > currentTime) next = Math.min(next, entry.time);
        });
        if (!current) {
          // Existing preheat pages may only have the final event time configured.
          // Retain an earlier manual stage until that next scheduled phase begins.
          var firstScheduled = Math.min.apply(null, entries.map(function (entry) { return stages.indexOf(entry.stage); }));
          stages.slice(0, firstScheduled).forEach(function (item) {
            if (item.dataset.bfTimelineHighlight === 'true') current = { stage: item };
          });
        }
        var stage = current && current.stage;
        if (!applied || stage !== active) {
          stages.forEach(function (item) {
            var selected = item === stage;
            item.classList.toggle('is-highlighted', selected);
            if (selected) item.setAttribute('aria-current', 'step');
            else item.removeAttribute('aria-current');
          });
          if (stage) reveal(stage, applied);
          active = stage;
          applied = true;
        }
      }
      // Once the final stage has started, only resume/server-sync events need work.
      if (Number.isFinite(next) || !Number.isFinite(currentTime)) {
        timer = setTimeout(function () { update(); syncClock(false); }, Number.isFinite(next) ? Math.min(60000, Math.max(50, next - currentTime)) : 60000);
      }
    }
    async function syncClock(force) {
      if (!automatic || events.signal.aborted || syncing || (!force && performance.now() - lastAttempt < 30000)) return;
      syncing = true;
      lastAttempt = performance.now();
      try {
        var response = await fetch(location.href, { method: 'HEAD', cache: 'no-store', signal: events.signal });
        var serverTime = Date.parse(response.headers.get('Date') || '');
        if (!events.signal.aborted && response.ok && Number.isFinite(serverTime)) {
          clockTime = serverTime;
          clockAt = performance.now();
          update();
        }
      } catch (_) {
        // Offline/aborted refreshes retain the server-rendered clock, never Date.now().
      } finally { syncing = false; }
    }
    function resume() {
      if (document.hidden || events.signal.aborted) return;
      if (automatic) { update(); syncClock(true); }
      if (revealPending) reveal(revealPending, false);
    }
    function cleanup() {
      events.abort();
      clearTimeout(timer);
      cancelAnimationFrame(revealFrame);
      if (observer) observer.disconnect();
      delete root.dataset.bfTimelineReady;
      cleanups.delete(root);
    }
    cleanups.set(root, cleanup);
    root.dataset.bfTimelineReady = 'true';
    manual();
    root.addEventListener('shopify:block:select', function (event) {
      var stage = stages.find(function (item) { return item.contains(event.target) || item.dataset.bfTimelineStageId === (event.detail && event.detail.blockId); });
      if (stage) reveal(stage, false);
    }, options);
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(function () { if (revealPending) reveal(revealPending, false); });
      observer.observe(root);
    } else window.addEventListener('resize', function () { if (revealPending) reveal(revealPending, false); }, options);
    document.addEventListener('visibilitychange', resume, options);
    window.addEventListener('pageshow', resume, options);
    window.addEventListener('online', resume, options);
    if (automatic) { update(); syncClock(true); }
  }

  function initWithin(target) {
    if (target.matches && target.matches('[data-bf-timeline]')) init(target);
    if (target.querySelectorAll) target.querySelectorAll('[data-bf-timeline]').forEach(init);
  }
  window[key] = { initWithin: initWithin };
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll ? Array.from(event.target.querySelectorAll('[data-bf-timeline]')) : [];
    if (event.target.matches && event.target.matches('[data-bf-timeline]')) roots.push(event.target);
    roots.forEach(function (root) { var cleanup = cleanups.get(root); if (cleanup) cleanup(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
  else initWithin(document);
})();
